export default {
    setTenants(state, {tenants})
    {
        state.tenants = tenants;
    },
    setCurrentTenant(state, {tenant})
    {
        state.currentTenant = tenant;
    },
    SET_COUNT_PER_POOL(state, data) {
        state.countPerPool = data;
    },
    SET_PAGINATED_TENANTS(state, paginatedTenants) {
        state.paginatedTenants = paginatedTenants;
    }
}